export default __webpack_public_path__ + "static/media/check.dee363aa.svg";